import { render } from "./BrowseFile.vue?vue&type=template&id=7d927cf2&scoped=true"
import script from "./BrowseFile.vue?vue&type=script&lang=js"
export * from "./BrowseFile.vue?vue&type=script&lang=js"

import "./BrowseFile.vue?vue&type=style&index=0&id=7d927cf2&scoped=true&lang=css"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d927cf2"]])

export default __exports__